import { createSelector } from 'reselect';
import {
  getFilterAttribute,
  getFilterOperator,
  getFilterValue
} from '../filterSelectors';
import { filterItemsFunctionCreator } from '../util/filterItems';
import {
  ULTRASOUND_FETCH_ALL,
  ULTRASOUND_FETCH_ALL_SUCCESS,
  ULTRASOUND_FETCH_ALL_FAIL,
  ULTRASOUND_SET_SORT,
  ULTRASOUND_SET_PAGE,
  ULTRASOUND_SET_PAGE_SIZE
} from './constants';

const initialState = {
  scans: {},
  sessionIds: {},
  fetching: false,
  fetched: false,
  sortAttribute: 'id',
  sortAttributeInverted: false,
  page: 1,
  pageSize: 20
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ULTRASOUND_FETCH_ALL:
      return { ...state, fetching: true };
    case ULTRASOUND_FETCH_ALL_SUCCESS: {
      const scans = {};
      const sessionIds = {};
      action.scans.forEach(scan => {
        scans[scan.id] = scan;
        sessionIds[scan.scanId] = scan.id;
      });
      return { ...state, fetched: true, fetching: false, scans, sessionIds };
    }
    case ULTRASOUND_FETCH_ALL_FAIL:
      return { ...state, fetching: false, fetched: true };
    case ULTRASOUND_SET_SORT: {
      const sortAttributeInverted =
        state.sortAttribute === action.sort ?
          !state.sortAttributeInverted : false;
      return { ...state, sortAttribute: action.sort, sortAttributeInverted };
    }
    case ULTRASOUND_SET_PAGE:
      return { ...state, page: action.page };
    case ULTRASOUND_SET_PAGE_SIZE:
      return { ...state, pageSize: action.size };
  }
  return state;
};

const scans = state => state.ultrasound.scans;
const sessionIds = state => state.ultrasound.sessionIds;
const fetching = state => state.ultrasound.fetching;
const fetched = state => state.ultrasound.fetched;
const sortAttribute = state => state.ultrasound.sortAttribute;
const sortAttributeInverted = state => state.ultrasound.sortAttributeInverted;
const page = state => state.ultrasound.page;
const pageSize = state => state.ultrasound.pageSize;

export const getScansObj = createSelector(
  scans, scans => scans
);
export const getSessionIds = createSelector(
  sessionIds, ids => ids
);
export const hasFetchedScans = createSelector(
  fetched, fetched => fetched
);
export const getUltrasoundSort = createSelector(
  sortAttribute, sortAttribute => sortAttribute
);
export const getUltrasoundSortInverted = createSelector(
  sortAttributeInverted, sortAttributeInverted => sortAttributeInverted
);
export const getUltrasoundPage = createSelector(
  page, page => page
);
export const getUltrasoundPageSize = createSelector(
  pageSize, pageSize => pageSize
);
export const getUltrasoundScans = createSelector(
  scans, scans => Object.values(scans)
);
export const getUltrasoundCount = createSelector(
  getUltrasoundScans, scans => scans.length
);
const filterItems = filterItemsFunctionCreator([
  { attribute: 'technician', operator: 'contains' },
  { attribute: 'farm', operator: 'contains' },
  { attribute: 'scanId', operator: 'contains' }
]);
export const getFilteredScans = createSelector(
  [getUltrasoundScans, getFilterAttribute, getFilterOperator, getFilterValue],
  filterItems
);
export const getSortedScans = createSelector(
  [getFilteredScans, sortAttribute, sortAttributeInverted],
  (scans, attribute, inverted) => {
    return [ ...scans ].sort((a, b) => {
      if (a[attribute] < b[attribute]) return inverted ? 1 : -1;
      if (a[attribute] > b[attribute]) return inverted ? -1 : 1;
    });
  }
);
export const getPageOfScans = createSelector(
  [getSortedScans, page, pageSize], (scans, page, size) => {
    const start = (page - 1) * size;
    const end = page * size;
    return scans.slice(start, end);
  }
);
export const isFetchingUltrasoundScans = createSelector(
  fetching, fetching => fetching
);

export default reducer;
